/** localStorage for Q7.2 — how many EVO refills per purchase (single choice; stored as one-element array). */
export const Q7_2_STORAGE_KEY = 'ploomsurvey:q7_2';

export const Q7_2_PACK_OPTIONS = [
  '1 Pack',
  '2 Packs',
  '3 Packs',
  '4 Packs',
  '5 Packs',
  'More than 5 Packs',
] as const;

export type Q7_2Answers = {
  selected: string[];
};

export function readQ7_2Answers(): Q7_2Answers | null {
  try {
    const raw = localStorage.getItem(Q7_2_STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw) as unknown;
    if (typeof o !== 'object' || o === null) return null;
    const sel = (o as { selected?: unknown }).selected;
    if (!Array.isArray(sel)) return null;
    const selected = sel.filter((x): x is string => typeof x === 'string');
    /** Legacy data may have multiple selections; only the first is kept. */
    return { selected: selected.length > 1 ? [selected[0]] : selected };
  } catch {
    return null;
  }
}

export function writeQ7_2Answers(data: Q7_2Answers): void {
  try {
    localStorage.setItem(Q7_2_STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function clearQ7_2Answers(): void {
  try {
    localStorage.removeItem(Q7_2_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function isQ7_2Complete(): boolean {
  const a = readQ7_2Answers();
  return a != null && a.selected.length > 0;
}
